import React from 'react';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import Checkbox from '@material-ui/core/Checkbox';
import PropTypes from 'prop-types';


export default function CheckboxInput(props) {

  const { errors, label, helperText, labelClassName, ...checkboxProps } = props;

  return (
    <FormControl error={!!errors} className='checkbox-input'>
      <FormControlLabel
        control={
          <Checkbox
            {...checkboxProps}
            color="primary"
          />
        }
        label={label}
        className={labelClassName}
      />
      <FormHelperText>{helperText}</FormHelperText>
      <FormHelperText>{errors && errors.message}</FormHelperText>
    </FormControl>
  )
}

CheckboxInput.propTypes = {
  id: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  checked: PropTypes.bool.isRequired,
  name: PropTypes.string.isRequired,
  inputRef: PropTypes.func.isRequired,
  label: PropTypes.oneOfType([
    PropTypes.string.isRequired,
    PropTypes.object.isRequired
  ]),
  errors: PropTypes.object,
  helperText: PropTypes.string,
}


// WEBPACK FOOTER //
// ./src/components/Helpers/Inputs/CheckboxInput.js